import axios from './httpConfig.js'
// ******************库房管理 -- 库房******************/
// 库房列表
export function GetWarehouseList(param) {
	return axios.post('/admin/warehouse/list', param)
}

// 新增库房
export function AddWarehouse(param) {
	return axios.post('/admin/warehouse/add', param)
}
// 删除库房
export function DeleteWarehouse(param) {
	return axios.post('/admin/warehouse/delete', param)
}
// 修改库房
export function EditWarehouse(param) {
	return axios.post('/admin/warehouse/edit', param)
}

// 禁用库房
export function DisabledWarehouse(param) {
	return axios.post('/admin/warehouse/disabled', param)
} 

// 设置默认库房
export function SetDefaultWarehouse(param) {
	return axios.post('/admin/warehouse/set/default', param)
} 

// 根据出入库类型获取上次出入库的库房
export function GetLastSetWarehouse(param) {
	return axios.post('/admin/warehouse/get/last/warehouse', param)
} 

// ******************库房管理 -- 货位******************/
// 货位列表
export function GetLocationList(param) {
	return axios.post('/admin/warehouse/location/list', param)
}

// 新增货位
export function AddLocation(param) {
	return axios.post('/admin/warehouse/location/add', param)
}
// 删除货位
export function DeleteLocation(param) {
	return axios.post('/admin/warehouse/location/delete', param)
}
// 修改货位
export function EditLocation(param) {
	return axios.post('/admin/warehouse/location/edit', param)
}

// 禁用货位
export function DisabledLocation(param) {
	return axios.post('/admin/warehouse/location/disabled', param)
} 